// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

class Auth {
  setToken (token) {
    localStorage.setItem('jwt', token)
    const expiredAt = Date.now() + 24 * 60 * 60 * 1000 // 24 hours
    localStorage.setItem('expiredAt', expiredAt)
  }

  getToken () {
    return localStorage.getItem('jwt')
  }

  getExpiredAt () {
    return localStorage.getItem('expiredAt')
  }

  setRefreshToken (token) {
    localStorage.setItem('refresh_token', token)
  }

  getRefreshToken () {
    return localStorage.getItem('refresh_token')
  }

  setUser (user) {
    localStorage.setItem('user', JSON.stringify(user))
  }

  getUser () {
    const userJson = localStorage.getItem('user')
    if (userJson) {
      const user = JSON.parse(localStorage.getItem('user'))
      if (!Array.isArray(user.roleList)) {
        user.roleList = []
      }
      return user
    }
    return null
  }

  clear () {
    localStorage.clear()
  }

  isAuthorized () {
    return !!this.getToken() && !!this.getRefreshToken()
  }
}
const auth = new Auth()
export { auth }
export default auth
